import { render, staticRenderFns } from "./ItemCardSimpleSlider.vue?vue&type=template&id=60a01846&"
import script from "./ItemCardSimpleSlider.vue?vue&type=script&lang=js&"
export * from "./ItemCardSimpleSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports